import { CaretRightIcon } from "Components/Icons/CaretRightSmall";
import { CaretDownIcon } from "Components/Icons/CaretDown";
import React from "react";
import { useContext } from "react";
import {AccordionContext, useAccordionButton} from "react-bootstrap";

type CustomToggleProps = {
    eventKey: string,
    disabled: boolean,
    level?: number,
    toggleButtonRef: React.MutableRefObject<Record<string, HTMLButtonElement | null>>
}

export const CustomToggle = ({ eventKey, disabled, level, toggleButtonRef }: CustomToggleProps) => {
    const decoratedOnClick = useAccordionButton(eventKey, () => { });
    const { activeEventKey } = useContext(AccordionContext);

    const setRef = (button: HTMLButtonElement | null) => {
        if ((level && level > 0) || activeEventKey !== eventKey) {
            toggleButtonRef.current[eventKey] = button;
        } else {
            toggleButtonRef.current[eventKey] = null;
        }
    };

    return (
        <button
            type="button"
            className={`toggle_${eventKey}`}
            id={`toggle_${eventKey}`}
            style={{background: "transparent", border: "none"}}
            onClick={decoratedOnClick}
            disabled={disabled}
            ref={setRef}
        >
            {activeEventKey === eventKey ?
                <CaretDownIcon size="16" className={disabled ? "drop-icon-disabled" : "drop-icon"}/> :
                <CaretRightIcon className={disabled ? "drop-icon-disabled" : "drop-icon"}/>}
        </button>
    );
};

